import React from 'react';

import { FormControlLabel, Switch } from '@mui/material';

export default function ProximlImagesDisabledField({
  value,
  setValue,
  setChanged,
}) {
  const handleChange = () => {
    setChanged();
    setValue(!value);
  };

  return (
    <FormControlLabel
      control={<Switch checked={value} onChange={handleChange} />}
      label='Disable proxiML built-in image download'
    />
  );
}
